import { render, staticRenderFns } from "./WorkConstructs.vue?vue&type=template&id=4ceef34c"
import script from "./WorkConstructs.vue?vue&type=script&lang=ts"
export * from "./WorkConstructs.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports